import type { Auth } from 'firebase/auth';

// Añade el token de la sesión de Firebase a todas las llamadas a la API propia
// (/api/… y la URL directa de la función). El servidor comprueba con él que
// quien pide es el dueño del pedido o del usuario (ver RUTAS_DE_CLIENTE en
// functions/index.js). No toca las llamadas que ya llevan su propia cabecera
// (el panel de admin manda su token) ni las de otros dominios.
export function instalarFetchConSesion(auth: Auth, apiDirecta: string) {
  if (typeof window === 'undefined' || (window as any).__fetchConSesion) return;
  (window as any).__fetchConSesion = true;
  const original = window.fetch.bind(window);

  const esApiPropia = (url: string) => {
    if (url.startsWith('/api/')) return true;
    try {
      const u = new URL(url, window.location.href);
      return (u.origin === window.location.origin && u.pathname.startsWith('/api/')) || (!!apiDirecta && u.href.startsWith(apiDirecta));
    } catch { return false; }
  };

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    try {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      if (esApiPropia(url)) {
        const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
        if (!headers.has('Authorization') && !headers.has('x-admin-token')) {
          await auth.authStateReady();
          const user = auth.currentUser;
          if (user) {
            headers.set('Authorization', `Bearer ${await user.getIdToken()}`);
            init = { ...init, headers };
          }
        }
      }
    } catch { /* sin token: la petición sale igual */ }
    return original(input, init);
  };
}
